import { useState } from "react";

import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

import { getPaginationItems } from "@/lib/pagination";

import { ConnectedDirectOfferDetails } from "../../DirectOfferDetails";
import { DepositCard } from "../DepositCard";
import { Deposit } from "../DepositCard/deposit-dtos";
import { DEPOSITS_PAGE_SIZE } from "../utils";

interface Props {
  deposits: Deposit[];
  totalItems: number;
  page: number;
  onPageChange: (page: number) => void;
  onClickAggregatorDetails: (id: number) => void;
  readOnly?: boolean;
}

export const DepositsList = ({
  deposits,
  totalItems,
  page,
  onPageChange,
  onClickAggregatorDetails,
  readOnly = false,
}: Props) => {
  const [offerDeposit, setOfferDeposit] = useState<Deposit | undefined>(undefined);

  const totalPages = Math.max(1, Math.ceil(totalItems / DEPOSITS_PAGE_SIZE));

  return (
    <div className="flex flex-col gap-4">
      {deposits.map(deposit => (
        <DepositCard
          key={deposit.id}
          deposit={deposit}
          onClickAggregatorDetails={onClickAggregatorDetails}
          onMakeOffer={readOnly ? undefined : setOfferDeposit}
        />
      ))}

      {totalPages > 1 && (
        <Pagination className="pt-2">
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                onClick={() => page > 1 && onPageChange(page - 1)}
                disabled={page <= 1}
              />
            </PaginationItem>
            {getPaginationItems(page, totalPages).map((item, index) =>
              item === "ellipsis" ? (
                <PaginationItem key={`ellipsis-${index}`}>
                  <PaginationEllipsis />
                </PaginationItem>
              ) : (
                <PaginationItem key={item}>
                  <PaginationLink isActive={item === page} onClick={() => onPageChange(item)}>
                    {item}
                  </PaginationLink>
                </PaginationItem>
              )
            )}
            <PaginationItem>
              <PaginationNext
                onClick={() => page < totalPages && onPageChange(page + 1)}
                disabled={page >= totalPages}
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      )}

      {!readOnly && (
        <ConnectedDirectOfferDetails
          isOpen={!!offerDeposit}
          onCancel={() => setOfferDeposit(undefined)}
          deposit={offerDeposit}
        />
      )}
    </div>
  );
};
